module.exports = __webpack_public_path__ + "static/media/xrj.df5c0607.jpg";